import {useEffect,} from 'react';

import {useCustomers} from '../hooks/useCustomers.ts';
import {FieldProps} from 'formik';
import {Customer} from "../types.ts";
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {TextInputProps} from "@mantine/core";


export const CustomersAutocomplete = (props: FieldProps & TextInputProps) => {


    const {
        items: records,
        loading,
        fetchRecords
    } = useCustomers();


    useEffect(() => {
        fetchRecords();
    }, []);


    return (
        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: Customer) => (record.name)}
            getSelectedOption={(record: Customer) => record.name}
            isLoading={loading}
            {...props}
        />
    );

};